import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthTreatment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3 7C3 6.44772 3.44772 6 4 6H20C20.5523 6 21 6.44772 21 7V19C21 19.5523 20.5523 20 20 20H4C3.44772 20 3 19.5523 3 19V7ZM5 8V18H19V8H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12 10C12.5523 10 13 10.4477 13 11V15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15V11C11 10.4477 11.4477 10 12 10Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15 13C15 13.5523 14.5523 14 14 14H10C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12H14C14.5523 12 15 12.4477 15 13Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.96666 6.25609C9.82701 6.78381 9.28873 7.10296 8.75746 6.97014C8.22167 6.83619 7.89591 6.29326 8.02986 5.75746L9 6C8.02986 5.75746 8.03 5.7569 8.03014 5.75633L8.03044 5.75514L8.03108 5.75261L8.03253 5.74699L8.03612 5.73345C8.03883 5.72343 8.04218 5.71141 8.04623 5.69754C8.05431 5.66981 8.06522 5.63453 8.07939 5.59277C8.10766 5.50944 8.14932 5.39914 8.20812 5.27085C8.32499 5.01586 8.51444 4.67919 8.80992 4.3415C9.42374 3.63998 10.4417 3 12 3C13.5583 3 14.5763 3.63998 15.1901 4.3415C15.4856 4.67919 15.675 5.01586 15.7919 5.27085C15.8507 5.39914 15.8923 5.50944 15.9206 5.59277C15.9348 5.63453 15.9457 5.66981 15.9538 5.69754C15.9578 5.71141 15.9612 5.72343 15.9639 5.73345L15.9675 5.74699L15.9689 5.75261L15.9696 5.75514L15.9699 5.75633C15.97 5.7569 15.9701 5.75746 15 6L15.9701 5.75746C16.1041 6.29326 15.7783 6.83619 15.2425 6.97014C14.7113 7.10296 14.173 6.78381 14.0333 6.25609C14.0323 6.25207 14.0312 6.24803 14.0302 6.24399L14.0309 6.24666L14.0318 6.25011L14.0331 6.25507C14.0338 6.25753 14.034 6.25831 14.0338 6.25754C14.0337 6.25726 14.0336 6.25677 14.0333 6.25609C14.0324 6.25302 14.0302 6.24595 14.0267 6.23536C14.0178 6.20931 14.0009 6.16336 13.9737 6.10415C13.9187 5.98414 13.8269 5.82081 13.6849 5.6585C13.4237 5.36001 12.9417 5 12 5C11.0583 5 10.5763 5.36001 10.3151 5.6585C10.1731 5.82081 10.0813 5.98414 10.0263 6.10415C9.99912 6.16336 9.98219 6.20931 9.97335 6.23536C9.96975 6.24594 9.96758 6.25301 9.96666 6.25609Z",
			fill: "currentColor"
		})
	]
});
export default SvgHealthTreatment;
